import { useDispatch } from "react-redux";
import clsx from "clsx";
import { Divider, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { OUTER, POSTCODE, SECTOR } from "../../../consts/layers";
import { palette } from "../../../theme/palette";

import { searchHandler } from "../../../reducers/ownApp/thunkActions";

import { View } from "../../View";
import { BaseSummaryPopover } from "../Base/BaseSummaryPopover";

const useStyles = makeStyles(() => ({
  header: {
    color: palette.typography.black.medium,
  },
  postcodeLine: {
    fontWeight: "bold",
    color: palette.typography.black.solid,
  },
  postcode: {
    textDecorationLine: "underline",
    cursor: "pointer",
  },
  row: {
    display: "flex",
    lineHeight: "30px",
  },
  left: {
    flex: 3,
  },
  right: {
    flex: 2,
  },
  divider: {
    height: "1px",
    background: palette.typography.black.neutral,
  },
}));

const UnallocatedPostcodePopover = ({
  open,
  anchorEl,
  onClose,
  unallocatedAreas,
}) => {
  const styles = useStyles();
  const dispatch = useDispatch();

  const goToPostcode = ({ outer, sector, postcode }) => {
    let type = OUTER;
    let value = outer;

    if (postcode) {
      type = POSTCODE;
      value = postcode;
    } else if (sector) {
      type = SECTOR;
      value = sector;
    }
    onClose();
    dispatch(
      searchHandler({
        item: {
          type,
          value,
        },
        type: "POSTCODE",
      })
    );
  };

  return (
    <BaseSummaryPopover
      id={"unallocatedPostcodePopover"}
      title={"Unallocated Postcodes"}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      width={"220px"}
    >
      <View className={clsx(styles.row, styles.header)}>
        <View className={styles.left}>Postcode</View>
        <View className={styles.right}>From</View>
      </View>

      {unallocatedAreas.map(({ outer, sector, postcode, from }) => (
        <View key={postcode || sector || outer}>
          <View className={clsx(styles.row, styles.postcodeLine)}>
            <View className={styles.left}>
              <Typography
                className={styles.postcode}
                onClick={() => goToPostcode({ outer, sector, postcode })}
              >
                {postcode || sector || outer}
              </Typography>
            </View>
            <View className={styles.right}>{from || "All Times"}</View>
          </View>
          <Divider className={styles.divider} />
        </View>
      ))}
    </BaseSummaryPopover>
  );
};

export default UnallocatedPostcodePopover;
